import { config } from "./configuration/app/app-config"

const enableServiceWorkerMock = async (): Promise<void> => {
    if (config.useApiMocks && (config.isDev || config.mode === "perf")) {
        const { worker } = await import("./mocks/browser")
        await worker.start()
        return Promise.resolve()
    } else {
        return Promise.resolve()
    }
}
export { enableServiceWorkerMock }
